"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchTypes = exports.WSSearch = void 0;
var _react = _interopRequireWildcard(require("react"));
var _searchIcon = _interopRequireDefault(require("../../../assets/teacher/images/worksheets/search-icon.svg"));
var _crossIcon = _interopRequireDefault(require("../../../assets/teacher/images/worksheets/cross-icon.svg"));
var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));
var _reactDebounceInput = require("react-debounce-input");
var _searchDropdownFallback = require("apps/teacher/fallbackComponents/worksheet/searchDropdownFallback");
var PrintableWorksheetsApi = _interopRequireWildcard(require("../../api"));
var _state = require("printableWorksheets/state");
var _OutsideClickHandler = _interopRequireDefault(require("../OutsideClickHandler"));
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _printableWorksheets = require("printableWorksheets");
var _AppMediaProvider = require("../../../baseStyles/AppMediaProvider");
var _searchiIcon = _interopRequireDefault(require("./searchi-icon2.svg"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _InvisibleInput = _interopRequireDefault(require("../../../teacherDashboard/atoms/InvisibleInput"));
var _PDFViewer = _interopRequireDefault(require("../../../teacherDashboard/teacher/components/common/PDFViewer"));
require("./styles.scss");
require("../../../assets/teacher/stylesheets/teachers/pdf_viewer.scss");
var _common = require("apps/teacher/config/common");
var _wsPreview = _interopRequireDefault(require("./wsPreview"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var searchTypes = {
  TRENDING: 'Trending searches',
  RECENT: 'Recent searches',
  BEST_MATCHES: 'Best matches'
};

/**
 * This component renders the Search input and search dropdown on Worksheet page
 *
 * @property {Boolean} defaultSearch To show or hide extended search input
 * @property {String} subjectCode current subject selected
 * @property {Function} toggleDefaultSearch function to show or hide extended search input
 * @property {String} worksheetSearchValue stores values which is entered into search input
 * @property {String} gradeCode current grade code
 * @property {String} userId contains teacher id
 *
 */
exports.searchTypes = searchTypes;
var WSSearch = function WSSearch(_ref) {
  var _ref$defaultSearch = _ref.defaultSearch,
    defaultSearch = _ref$defaultSearch === void 0 ? false : _ref$defaultSearch,
    _ref$subjectCode = _ref.subjectCode,
    subjectCode = _ref$subjectCode === void 0 ? "math" : _ref$subjectCode,
    _ref$toggleDefaultSea = _ref.toggleDefaultSearch,
    toggleDefaultSearch = _ref$toggleDefaultSea === void 0 ? function () {} : _ref$toggleDefaultSea,
    _ref$worksheetSearchV = _ref.worksheetSearchValue,
    worksheetSearchValue = _ref$worksheetSearchV === void 0 ? '' : _ref$worksheetSearchV,
    _ref$gradeCode = _ref.gradeCode,
    gradeCode = _ref$gradeCode === void 0 ? "" : _ref$gradeCode,
    _ref$userId = _ref.userId,
    userId = _ref$userId === void 0 ? null : _ref$userId,
    _ref$searchPlaceholde = _ref.searchPlaceholder,
    searchPlaceholder = _ref$searchPlaceholde === void 0 ? null : _ref$searchPlaceholde;
  // const dispatch = useDispatch();

  var _useState = (0, _react.useState)(worksheetSearchValue),
    _useState2 = _slicedToArray(_useState, 2),
    worksheetName = _useState2[0],
    setWorksheetName = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    searchResults = _useState4[0],
    setSearchResults = _useState4[1];
  var _useState5 = (0, _react.useState)(searchTypes.RECENT),
    _useState6 = _slicedToArray(_useState5, 2),
    searchType = _useState6[0],
    setSearchType = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedPdf = _useState8[0],
    setSelectedPdf = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    trendingWorksheet = _useState10[0],
    setTrendingWorksheet = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = _slicedToArray(_useState11, 2),
    initialLoading = _useState12[0],
    setInitialLoading = _useState12[1];
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    activeGrade = _usePrintableWorkshee.activeGrade,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    downloadedWorksheets = _usePrintableWorkshee.downloadedWorksheets,
    activeBreadcrumb = _usePrintableWorkshee.activeBreadcrumb,
    setFilteredSearchTerm = _usePrintableWorkshee.setFilteredSearchTerm,
    setActiveScreen = _usePrintableWorkshee.setActiveScreen,
    setSearchScreenData = _usePrintableWorkshee.setSearchScreenData,
    setDownloadedWorksheets = _usePrintableWorkshee.setDownloadedWorksheets,
    setDownloadCount = _usePrintableWorkshee.setDownloadCount;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    currentDevice = _useAppMediaProvider.currentDevice,
    isDesktop = _useAppMediaProvider.isDesktop;
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    switchToIcon = _useState14[0],
    toggleSwitchToIcon = _useState14[1];
  var _useAppMediaProvider2 = (0, _AppMediaProvider.useAppMediaProvider)(),
    isMobile = _useAppMediaProvider2.isMobile;
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showWorksheetPreview = _useState16[0],
    setShowWorksheetPreview = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showUnlockButton = _useState18[0],
    setShowUnlockButton = _useState18[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    worksheetDetail = _useState20[0],
    setWorksheetDetail = _useState20[1];
  (0, _react.useEffect)(function () {
    if (isMobile) {
      toggleSwitchToIcon(true);
    } else {
      toggleSwitchToIcon(false);
    }
  }, [currentDevice]);
  (0, _react.useEffect)(function () {
    if (userId) {
      if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
        getTrendingWorksheets();
      } else {
        checkForFirstTimeClick([]);
      }
    }
  }, [userId]);
  (0, _react.useEffect)(function () {
    var _document$getElements;
    var wsRailsContainerDiv = (_document$getElements = document.getElementsByClassName('ws-rails-container')) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];
    if (wsRailsContainerDiv) {
      if (!defaultSearch && !initialLoading && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0) {
        wsRailsContainerDiv.style.pointerEvents = 'none';
      } else {
        wsRailsContainerDiv.style.pointerEvents = 'all';
      }
    }
  }, [defaultSearch, initialLoading, searchResults]);
  var checkForFirstTimeClick = function checkForFirstTimeClick() {
    var trendingWsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var alreadyFirstTime = localStorage.getItem("First_Time_Click_On_Search" + userId + subjectCode + gradeCode);
    if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      if (!alreadyFirstTime) {
        localStorage.setItem("First_Time_Click_On_Search" + userId + subjectCode + gradeCode, true);
        setSearchType(searchTypes.TRENDING);
        setSearchResults(trendingWsList);
        setInitialLoading(false);
      } else {
        getRecentUserSearches(trendingWsList);
      }
    }
  };
  var _onDownload = function onDownload(worksheetDetails) {
    if (worksheetDetails.id && userId) {
      // GlobalSpinner.show();
      fetch(worksheetDetails.pdf_url, {
        credentials: 'omit'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        // GlobalSpinner.hide();
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = worksheetDetails.title;
        a.target = '_system';
        a.click();
        a.remove();
        if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
          PrintableWorksheetsApi.postSaveUserDownload({
            userId: userId,
            params: {
              entity_id: worksheetDetails.id,
              entity_type: 'SearchContent'
            },
            callback: function callback() {
              showFlashMessage('Worksheet downloaded successfully', 'success');
              if (!downloadedWorksheets.find(function (ws) {
                return ws.id === worksheetDetails.id;
              })) {
                setDownloadedWorksheets(function (dws) {
                  return [].concat(_toConsumableArray(dws), [worksheetDetails]);
                });
                setDownloadCount(function (downloadCount) {
                  return downloadCount + 1;
                });
              }
              if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
                var _window;
                (_window = window) === null || _window === void 0 ? void 0 : _window.dispatchEvent(new CustomEvent('download-worksheets-update'));
                var props = {
                  worksheetName: worksheetDetails.title,
                  worksheetGrade: gradeCode.toLowerCase(),
                  worksheetCategory: "",
                  worksheetSubcategory: "",
                  from: selectedPdf ? "Preview" : "Worksheet Listing Page"
                };
                _events["default"].downloadedWorksheet(props);
              }
            }
          });
        }
      })["catch"](function (e) {
        // sendErrorToSentry(new Error("Worksheet download failed"), worksheetDetails)
      });
    }
  };
  var onSearchInputChange = function onSearchInputChange(e) {
    setWorksheetName(e.target.value);
    if (e.target.value !== "") {
      // getSearchResults api returns empty in case of single character
      if (e.target.value.length > 1) {
        getSearchResults(e.target.value);
      }
    } else {
      setSearchType(searchTypes.TRENDING);
      setSearchResults(trendingWorksheet);
    }
  };
  var getSearchResults = function getSearchResults() {
    var _activeBreadcrumb$;
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    setSearchType(searchTypes.BEST_MATCHES);
    PrintableWorksheetsApi.getSearchResults({
      params: {
        query: query,
        grade: gradeCode,
        subject: (activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : (_activeBreadcrumb$ = activeBreadcrumb[0]) === null || _activeBreadcrumb$ === void 0 ? void 0 : _activeBreadcrumb$.title) === "Math" ? _state.SubjectCodes.MATH : _state.SubjectCodes.ELA,
        page_number: 0,
        page_size: 10
      },
      callback: function callback(callbackData) {
        var _callbackData$searche;
        setSearchResults(callbackData.searches);
        var props = {
          searchTerm: query,
          countOfSearchResults: (_callbackData$searche = callbackData.searches) === null || _callbackData$searche === void 0 ? void 0 : _callbackData$searche.length,
          grade: onboardingGrade
        };
        _events["default"].startedPrintablesSearch(props);
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to getSearchResults on search worksheet screen"), { error: err })
      }
    });
  };
  var postUserSearches = function postUserSearches(_ref2) {
    var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "" : _ref2$type,
      _ref2$searchTerm = _ref2.searchTerm,
      searchTerm = _ref2$searchTerm === void 0 ? "" : _ref2$searchTerm,
      _ref2$worksheetId = _ref2.worksheetId,
      worksheetId = _ref2$worksheetId === void 0 ? "" : _ref2$worksheetId;
    var params = {};
    if (type === "SEARCH") {
      params = {
        entity_type: "search",
        search_term: searchTerm,
        subject: subjectCode,
        grade: gradeCode
      };
    } else {
      params = {
        entity_type: "worksheet_select",
        entity_id: worksheetId,
        subject: subjectCode,
        grade: gradeCode
      };
    }
    PrintableWorksheetsApi.postUserSearches({
      userId: userId,
      params: params,
      callback: function callback(res) {
        var _res$search_entity;
        setFilteredSearchTerm(res === null || res === void 0 ? void 0 : (_res$search_entity = res.search_entity) === null || _res$search_entity === void 0 ? void 0 : _res$search_entity.search_term);
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to postUserSearches on search worksheet screen"), { error: err })
      }
    });
  };
  var getRecentUserSearches = function getRecentUserSearches() {
    var trendingWsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    PrintableWorksheetsApi.getRecentUserSearches({
      userId: userId,
      params: {
        subject: subjectCode,
        grade: gradeCode,
        page_number: 0,
        page_size: 10
      },
      callback: function callback(callbackData) {
        if (callbackData.length > 0) {
          getSearchWorksheetByIds(callbackData);
        } else {
          setSearchType(searchTypes.TRENDING);
          setSearchResults(trendingWsList);
          setInitialLoading(false);
        }
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to getRecentUserSearches on search worksheet screen"), { error: err })
      }
    });
  };
  var getWorksheetIds = function getWorksheetIds(result) {
    var ids = [];
    result.map(function (item) {
      var _item$search_entity;
      if ((item === null || item === void 0 ? void 0 : (_item$search_entity = item.search_entity) === null || _item$search_entity === void 0 ? void 0 : _item$search_entity.entity_type) === 'WORKSHEET_SELECT') {
        ids.push(item.search_entity.entity_id);
      }
    });
    return ids;
  };
  var modifyRecentSearches = function modifyRecentSearches(_ref3) {
    var data = _ref3.data,
      _ref3$worksheetList = _ref3.worksheetList,
      worksheetList = _ref3$worksheetList === void 0 ? [] : _ref3$worksheetList;
    var recentSearches = data.map(function (item) {
      var _item$search_entity2;
      var modifiedSearch = {};
      if ((item === null || item === void 0 ? void 0 : (_item$search_entity2 = item.search_entity) === null || _item$search_entity2 === void 0 ? void 0 : _item$search_entity2.entity_type) === 'WORKSHEET_SELECT') {
        modifiedSearch = worksheetList.find(function (worksheet) {
          return worksheet.id === item.search_entity.entity_id;
        });
      } else {
        modifiedSearch = _objectSpread(_objectSpread({}, item.search_entity), {}, {
          title: item.search_entity.search_term
        });
      }
      return modifiedSearch;
    });
    return recentSearches;
  };
  var getSearchWorksheetByIds = function getSearchWorksheetByIds(data) {
    var ids = getWorksheetIds(data);
    if (ids.length !== 0) {
      PrintableWorksheetsApi.getWorksheetsByIds({
        params: {
          ids: getWorksheetIds(data)
        },
        callback: function callback(callbackData) {
          setSearchResults(modifyRecentSearches({
            data: data,
            worksheetList: callbackData.searches
          }));
          setInitialLoading(false);
        },
        errorCallback: function errorCallback(err) {
          // sendErrorToSentry(new Error("failed to getSearchWorksheetByIds on search worksheet screen"), { error: err })
        }
      });
    } else {
      setSearchResults(modifyRecentSearches({
        data: data,
        worksheetList: []
      }));
      setInitialLoading(false);
    }
  };
  var getTrendingWorksheets = function getTrendingWorksheets() {
    PrintableWorksheetsApi.getTrendingWorksheets({
      params: {
        grade: gradeCode,
        subject: subjectCode
      },
      callback: function callback(callbackData) {
        setTrendingWorksheet(callbackData.searches);
        checkForFirstTimeClick(callbackData.searches);
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to getTrendingWorksheet on search worksheet screen"), { error: err })
      }
    });
  };
  var searchOnClickHandler = function searchOnClickHandler() {
    toggleDefaultSearch(false);
    fireViewedWorksheetSearchDropdown();
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' && e.target.value.length > 0) {
      fireViewedWorksheetSearchResultsPage();
      postUserSearches({
        type: "SEARCH",
        searchTerm: e.target.value
      });
      toggleDefaultSearch(true);
      setWorksheetName(e.target.value);
      goToSearchWorksheetScreen(e.target.value);
    }
  };
  var individualSearchClickHandler = function individualSearchClickHandler(item, index) {
    fireInteractedWorksheetSearchDropdown(index);
    fireViewedWorksheetSearchResultsPage();
    toggleDefaultSearch(true);
    if (item.entity_type === "SEARCH") {
      setWorksheetName(item.title);
      goToSearchWorksheetScreen(item.title);
      postUserSearches({
        type: "SEARCH",
        searchTerm: item.title
      });
    } else {
      postUserSearches({
        type: "WORKSHEET_SELECT",
        worksheetId: item.id
      });
      worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? setSelectedPdf(item) : onSearchClick(item);
      // setSelectedPdf(item);
    }
  };

  var onSearchClick = function onSearchClick(wsDetail) {
    if (isDesktop) {
      setWorksheetDetail(wsDetail);
      setShowWorksheetPreview(true);
      window.parent.triggerIsFlutterHeaderClickDisabled && window.parent.triggerIsFlutterHeaderClickDisabled();
      if (!(0, _common.canDownloadWs)()) {
        setShowUnlockButton(true);
      }

      /// if preview popup is opened then unset all overflow properties in parent. (Safari/Firefox browser issue fix)
      var worksheetsRightDiv = window.document.getElementById('ws-right-div');
      worksheetsRightDiv.style.overflowX = 'unset';
      worksheetsRightDiv.style.overflowY = 'unset';
    } else {
      var _item;
      window.open((_item = item) === null || _item === void 0 ? void 0 : _item.pdf_url);
      _events["default"].downloadedWorksheetB2c({
        worksheetName: wsDetail.title,
        worksheetCode: wsDetail.code
      });
    }
  };
  (0, _react.useEffect)(function () {
    var worksheetsRightDiv = window.document.getElementById('ws-right-div');
    var wsPreview = window.document.getElementById('ws-preview-wrapper');
    /// if preview popup is opened then no overflow property should set. 
    if (selectedPdf) {
      if (worksheetsRightDiv && !wsPreview) {
        worksheetsRightDiv.style.overflowX = 'visible';
        worksheetsRightDiv.style.overflowY = 'visible';
      }
    } else {
      if (worksheetsRightDiv && !wsPreview) {
        worksheetsRightDiv.style.overflowY = 'auto';
        worksheetsRightDiv.style.overflowX = 'hidden';
      }
    }
  }, [selectedPdf]);
  var goToSearchWorksheetScreen = function goToSearchWorksheetScreen(title) {
    var _activeBreadcrumb$2;
    // dispatch({ type: ReducerConstants.SET_WORKSHEET_VALUE, payload: title });
    var params = {
      query: title,
      grade: gradeCode,
      subject: (activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : (_activeBreadcrumb$2 = activeBreadcrumb[0]) === null || _activeBreadcrumb$2 === void 0 ? void 0 : _activeBreadcrumb$2.title) === "Math" ? _state.SubjectCodes.MATH : _state.SubjectCodes.ELA,
      page_number: 0,
      page_size: 1000
    };
    setSearchScreenData({
      params: params,
      title: title,
      from: 'SEARCH'
    });
    setActiveScreen(_state.PRINTABLE_WORKSHEET_SCREENS.SEARCH);
  };
  var fireInteractedWorksheetSearchDropdown = function fireInteractedWorksheetSearchDropdown(index) {
    if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      var props = {
        clickedOn: "Search Result ".concat(index + 1)
      };
      _events["default"].interactedWorksheetSearchDropdown(props);
    } else {
      var _props = {
        searchTerm: worksheetName,
        searchResultSelected: "Search Result ".concat(index + 1),
        grade: activeGrade
      };
      _events["default"].selectedPrintablesSearch(_props);
    }
  };
  var fireViewedWorksheetSearchDropdown = function fireViewedWorksheetSearchDropdown() {
    _events["default"].viewedWorksheetSearchDropdown();
  };
  var fireViewedWorksheetSearchResultsPage = function fireViewedWorksheetSearchResultsPage() {
    _events["default"].viewedWorksheetSearchResultsPage();
  };
  var crossOnClickHandler = function crossOnClickHandler() {
    closeViewForSearch();
    setWorksheetName("");
  };
  var closeViewForSearch = function closeViewForSearch() {
    toggleDefaultSearch(true);
    setSearchResults([]);
    toggleSwitchToIcon(isMobile ? true : false);
    $('.worksheet-mobile-options').show();
  };
  var showViewForSearch = function showViewForSearch() {
    toggleDefaultSearch(false);
    toggleSwitchToIcon(false);
    $('.worksheet-mobile-options').hide();
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showWorksheetPreview && /*#__PURE__*/_react["default"].createElement(_wsPreview["default"], {
    worksheetDetails: worksheetDetail,
    setShowWorksheetPreview: setShowWorksheetPreview,
    showWorksheetPreview: showWorksheetPreview,
    showUnlockButton: showUnlockButton
  }), /*#__PURE__*/_react["default"].createElement(_OutsideClickHandler["default"], {
    outsideClickHandler: closeViewForSearch,
    "data-sentry-element": "OutsideClickHandler",
    "data-sentry-source-file": "wsSearch.tsx"
  }, switchToIcon && isMobile ? /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-icon-container",
    onClick: function onClick() {
      showViewForSearch();
      var elem = document.getElementById('ws-header');
      elem.scrollIntoView();
    }
  }, /*#__PURE__*/_react["default"].createElement(_searchiIcon["default"], null)), document.getElementById("searchIconPortal")) : /*#__PURE__*/_react["default"].createElement("div", {
    "data-test-id": "worksheet-search-container",
    className: "search-container ".concat(!defaultSearch ? "increase-width" : ""),
    id: "printables-search-icon"
  }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
    id: "input-search",
    type: "text",
    className: !defaultSearch ? "increase-width" : "",
    placeholder: searchPlaceholder ? searchPlaceholder : 'Search ' + subjectCode + ' worksheets...',
    onClick: searchOnClickHandler,
    autoComplete: "off",
    onChange: function onChange(e) {
      return onSearchInputChange(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    value: worksheetName,
    debounceTimeout: 400
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "input-search"
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "ws-search-icon"
  }, /*#__PURE__*/_react["default"].createElement(_searchIcon["default"], null)), !defaultSearch && /*#__PURE__*/_react["default"].createElement("i", {
    className: "ws-cross-icon"
  }, /*#__PURE__*/_react["default"].createElement(_crossIcon["default"], {
    onClick: crossOnClickHandler
  }))), !defaultSearch && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0 && (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD || !initialLoading) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-dropdown",
    ref: function ref(_ref4) {
      if (_ref4 && worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD) {
        var elementDetails = _ref4.getBoundingClientRect();
        _ref4.style.maxHeight = "calc(100vh - ".concat(elementDetails.top - 72, "px)");
      }
    }
  }, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-results"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-result-type"
  }, searchType), searchResults.map(function (item, index) {
    var _item$search_nodes_ti;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: item === null || item === void 0 ? void 0 : item.id,
      className: "search-result",
      onClick: function onClick() {
        individualSearchClickHandler(item, index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactHighlightWords["default"], {
      className: "title",
      highlightClassName: "highlight-class",
      searchWords: [worksheetName],
      autoEscape: true,
      textToHighlight: item === null || item === void 0 ? void 0 : item.title
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "tree-name"
    }, item.entity_type !== 'SEARCH' && /*#__PURE__*/_react["default"].createElement("span", null, " in ", item === null || item === void 0 ? void 0 : (_item$search_nodes_ti = item.search_nodes_titles) === null || _item$search_nodes_ti === void 0 ? void 0 : _item$search_nodes_ti.join('/ '))));
  })) : worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD && isMobile ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-search-result"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "heading"
  }, "No result found for this grade"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "body"
  }, "We couldn\u2019t understand what you mean, try searching something else."))), initialLoading && !defaultSearch && /*#__PURE__*/_react["default"].createElement(_searchDropdownFallback.SearchDropdownFallback, null)), selectedPdf && selectedPdf.pdf_url && /*#__PURE__*/_react["default"].createElement(_PDFViewer["default"], {
    title: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.title,
    subtitle: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.meta_description,
    file: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.pdf_url,
    onBack: function onBack() {
      return setSelectedPdf(null);
    },
    onDownload: function onDownload() {
      return _onDownload(selectedPdf);
    },
    showSave: false,
    isMobileView: true
  }), /*#__PURE__*/_react["default"].createElement(_InvisibleInput["default"], {
    "data-sentry-element": "InvisibleInput",
    "data-sentry-source-file": "wsSearch.tsx"
  }));
};
exports.WSSearch = WSSearch;